/** Mapping reducer names for each tab value. */
export const reducerName = {
    0: ['setOimDisputeUpdate', 'addOimDispute', 'deleteOimDispute'],
    1: ['setOexDisputeUpdate', 'addOexDispute', 'deleteOexDispute'],
    2: ['setAimDisputeUpdate', 'addAimDispute', 'deleteAimDispute'],
    3: ['setAexDisputeUpdate', 'addAexDispute', 'deleteAexDispute'],
    4: ['setTruckingDisputeUpdate', 'addTruckingDispute', 'deleteTruckingDispute'],
};

/** Mapping key names for different shipment types. */
export const keyName = {
    0: [
        'il_ocean_import_id',
        'oimDisputeUpdateForm',
        'oimHblUpdateForm',
        'oimContainerUpdateForm',
        'oimContainerAliasUpdateForm',
    ],
    1: ['il_ocean_export_id', 'oexDisputeUpdateForm', 'oexHblUpdateForm', 'oexContainerUpdateForm'],
    2: ['il_air_import_id', 'aimDisputeUpdateForm', 'aimHblUpdateForm', 'aimContainerUpdateForm'],
    3: ['il_air_export_id', 'aexDisputeUpdateForm', 'aexHblUpdateForm', 'aexContainerUpdateForm'],
    4: ['il_ftl_ltl_id', 'truckingDisputeUpdateForm', 'truckingBolUpdateForm'],
};
